import { fetchWithCache, getCachedData } from "../services/apiService";

export const advertiseGrab = async (direction, setAdvertisement) => {
  const cacheKey = `/api/advertisement/advertisementGrab_${direction}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    setAdvertisement(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/advertisement/advertisementGrab",
      {
        method: "POST",
        body: JSON.stringify({ direction }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    if (data) {
      setAdvertisement(data);
    }
  } catch (error) {
    // Keep showing cached data on error
  }
};
